import {en} from "./Translation_en";
import {Translation} from "./Translation";

const currentTranslation = en;


export const $t = (key: keyof Translation): string => {
	return (currentTranslation as object)[key as any] ?? key;
}

export const $ts = (key: keyof Translation, ...args): string => {
	const template = $t(key);
	return template?.replace(/\{\{(\d+)\}\}/g, (match, index) => args[index]) ?? key;
}